import { render, staticRenderFns } from "./ExerciseMuscleMap.vue?vue&type=template&id=dde5cf3a&scoped=true"
import script from "./ExerciseMuscleMap.vue?vue&type=script&lang=js"
export * from "./ExerciseMuscleMap.vue?vue&type=script&lang=js"
import style0 from "./ExerciseMuscleMap.vue?vue&type=style&index=0&id=dde5cf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde5cf3a",
  null
  
)

export default component.exports